module.exports = __webpack_public_path__ + "static/bcLogo-95f86c1fd1ccb0bd0b6020d2ffe3e153.png";